export default __webpack_public_path__ + "static/media/CNo.33-4.834dfdca.jpg";